import './AppTile.scss';


export default function AppTileSkeleton() {

  return (
      <div className={'app-tile block shadow loading'}>
      </div>
  );
}